/* Consent-gated OpenAI storefront Pixel. Purchase events use the signed server path. */
(function () {
  'use strict';

  if (window.__rtpOpenAIPixel || window.oaiq) return;
  if (location.hostname !== 'robotaxiplaybook.com') return;
  if (window.Shopify && window.Shopify.designMode) return;
  window.__rtpOpenAIPixel = true;

  var started = false;
  var ready = false;
  var pageSent = false;
  var productSent = false;
  var productVisible = false;
  var observer;
  var proof = document.querySelector('#inside header');
  if (proof && window.IntersectionObserver) {
    observer = new IntersectionObserver(function (entries) {
      productVisible = entries.some(function (entry) { return entry.isIntersecting && entry.intersectionRatio >= 0.5; });
      update();
    }, { threshold: 0.5 });
    observer.observe(proof);
  }

  function permitted() {
    try {
      var privacy = window.Shopify.customerPrivacy;
      return privacy.analyticsProcessingAllowed() === true &&
        privacy.marketingAllowed() === true &&
        privacy.saleOfDataAllowed() === true &&
        navigator.globalPrivacyControl !== true;
    } catch (_) {
      return false;
    }
  }

  function update() {
    var allowed = permitted();
    if (!allowed) {
      if (started) window.oaiq('consent', false);
      return;
    }
    if (!started) {
      started = true;
      var queue = function () { queue.q.push(arguments); };
      queue.q = [];
      window.oaiq = queue;
      // Never rely on the SDK's default consent. Load only after Shopify permits it.
      window.oaiq('consent', false);
      window.oaiq('init', { pixelId: '4nEgGyNnhhhxScFcRj8orh' });
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
      script.onload = function () { ready = true; update(); };
      document.head.appendChild(script);
      return;
    }
    if (!ready) return;
    window.oaiq('consent', true);
    if (!pageSent) {
      pageSent = true;
      window.oaiq('measure', 'page_viewed', { type: 'contents' }, { opt_out: true });
    }
    if (!productSent && productVisible) {
      productSent = true;
      if (observer) observer.disconnect();
      window.oaiq('measure', 'contents_viewed', {
        type: 'contents', contents: [{ id: '47683081896101', content_type: 'product' }]
      }, { opt_out: true });
    }
  }

  // Read permissions only. This integration never records consent for a visitor.
  document.addEventListener('visitorConsentCollected', update);
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) update();
    });
  }
})();
